import debounce from 'lodash/debounce';
import camelCase from 'lodash/camelCase';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
const MySwal = withReactContent(Swal);
import { AWS_S3_DOMAIN, IMAGE_NOT_AVAILABLE } from '~/config/constants';
import html2canvas from 'html2canvas';

export function titleCase(str) {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }

    return splitStr.join(' '); //https://stackoverflow.com/a/32589289/11297747
}

export const isEmpty = (obj) => {
    return Object.keys(obj).length === 0;
};

export const splitCamelCaseToString = (str) => {
    return (
        str // insert a space before all caps
            .replace(/([A-Z])/g, ' $1')
            // uppercase the first character
            .replace(/^./, function (str) {
                return str.toUpperCase();
            })
    ); //https://stackoverflow.com/a/4149393/11297747
};

export const squish = (string) => {
    if (string === undefined) return;
    const CONSECUTIVE_SPACES = /\s+/g;
    if (typeof string !== 'string') throw "Invalid 'string'. Expected String, got " + typeof string;
    return string.trim().replace(CONSECUTIVE_SPACES, ' ');
}; //https://github.com/chrissrogers/string-squish/blob/master/index.js

export function asyncDebounce(func, wait) {
    const debounced = debounce((resolve, reject, args) => {
        func(...args)
            .then(resolve)
            .catch(reject);
    }, wait);
    return (...args) =>
        new Promise((resolve, reject) => {
            debounced(resolve, reject, args);
        });
} //https://github.com/lodash/lodash/issues/4815#issuecomment-815866904

export const isNumeric = (num) => {
    if (!num) return false;

    return !isNaN(num);
};

export const toBase64 = (file) =>
    new Promise((resolve, reject) => {
        //if file is actually a path, then resolve EMPTY so that BE only care about actual base64string.
        if (typeof file !== 'object' || typeof file === 'undefined') {
            resolve('');
        }

        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    }); //https://stackoverflow.com/a/57272491/11297747

export const getBase64ImageFromUrl = (src) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'Anonymous';
        img.onload = function () {
            const canvas = document.createElement('CANVAS');
            const ctx = canvas.getContext('2d');
            canvas.height = this.naturalHeight;
            canvas.width = this.naturalWidth;
            ctx.drawImage(this, 0, 0);
            const outputFormat = basename(src).split('.')[1];
            let dataURL = canvas.toDataURL(`image/${outputFormat}`);
            dataURL = dataURL.replace(/^data:image\/(.*);base64,/, '');
            resolve(dataURL);
        };
        img.onerror = (error) => reject(error);

        img.src = src;
    });
}; //https://stackoverflow.com/a/20285053/11297747

export const base64ToFileObj = (base64Content, imageName, mimeType) => {
    if (!base64Content || !imageName || !mimeType) {
        alertSwal('warning', `Missing  params passed to function  ${base64ToFileObj.name}.`);
        return '';
    }

    const byteString = window.atob(base64Content);

    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);

    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    const blob = new Blob([ia], {
        type: mimeType,
    });

    return new File([blob], imageName + '.' + mimeType.split('/')[1], { type: mimeType });
}; //https://stackoverflow.com/a/38263409/11297747

export const truncateText = (input) => {
    if (!input) return;

    if (input.length > 50) {
        return input.substring(0, 50) + '...';
    }

    return input;
};

export const formLabel = (label) => {
    label = label.split('.').slice(-1)[0];

    if (!label.includes('_')) return titleCase(label.replace(/([A-Z])/g, ' $1'));

    label = label
        .split('_')[1]
        .replace(/([A-Z])/g, ' $1')
        .trim();

    label = label.replace(/number/i, 'No.');

    return titleCase(label);
};

export const basename = (path) => {
    return path.split(/[\\/]/).reverse()[0];
};

export const appUrl = () => window.location.protocol + '//' + window.location.host;

export const camelizeKeys = (obj) => {
    if (Array.isArray(obj)) {
        return obj.map((v) => camelizeKeys(v));
    } else if (obj != null && obj.constructor === Object) {
        return Object.keys(obj).reduce(
            (result, key) => ({
                ...result,
                [camelCase(key)]: typeof obj[key] === 'string' ? obj[key] : camelizeKeys(obj[key]),
            }),
            {},
        );
    }

    return obj;
}; //https://stackoverflow.com/a/50620653/11297747

export const alertSwal = (status, msg) => {
    MySwal.fire({
        title: <strong>{status === 'success' ? 'OK!' : 'Oops!'}</strong>,
        html: <i>{msg}</i>,
        icon: status,
        confirmButtonColor: 'rgb(64, 193, 232)',
    });
};

export const showToast = (msg) => {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2000,
        showCancelButton: false,
    });

    Toast.fire({
        icon: 'success',
        title: msg,
    });
};

export const handleImgOnError = (e) => {
    e.target.src = IMAGE_NOT_AVAILABLE;
};

//remove non-alphanumeric characters so that bg picture can be rendered without error.
export function escapeSpecialCharsInFilename(url) {
    const lastSlashIndex = url.lastIndexOf('/');
    const dirPath = url.substring(0, lastSlashIndex + 1);
    const filename = url.substring(lastSlashIndex + 1);
    const escapedFilename = filename.replace(/[^\w\s]/gi, function (match) {
        return '\\' + match;
    });

    return (url.includes('http') ? '' : AWS_S3_DOMAIN) + dirPath + escapedFilename + (isBlobUrl(url) ? '' : '?v=' + new Date().getTime());
}

//add version id to img url so that when user updates pic, it will always fetch new pic from server.
export function addVersionId(ImgUrl) {
    return (ImgUrl.includes('http') ? '' : AWS_S3_DOMAIN) + ImgUrl + (isBlobUrl(ImgUrl) ? '' : '?v=' + new Date().getTime());
}

export async function htmlToBase64Picture(element, width, height) {
    const canvas = await html2canvas(element, {
        scale: 5,
        logging: false,
        useCORS: true,
        backgroundColor: 'transparent',
    });

    canvas.resize = function (width, height) {
        const canvas = document.createElement('canvas');

        canvas.width = width;
        canvas.height = height;

        canvas.getContext('2d').drawImage(this, 0, 0, this.width, this.height, 0, 0, width, height);

        return canvas;
    };

    return canvas.resize(width, height).toDataURL('image/png', 1.0);
}

export function isBlobUrl(str) {
    const blobUrlRegex = /^blob:/;
    return blobUrlRegex.test(str);
}

export function blobUrlToFile(blobUrl) {
    return Promise.resolve(
        fetch(blobUrl)
            .then((response) => response.blob())
            .then((blob) => {
                return new File([blob], blob.name, { type: blob.type });
            }),
    );
}
